import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const TermsAndLicense = () => (
  <>
    <Helmet>
      <title>Termos e Licença | MediaHub</title>
      <meta
        name="description"
        content="Termos de serviço e licença de utilização do MediaHub."
      />
    </Helmet>

    <div className="min-h-screen bg-slate-950 text-slate-300 px-5 py-10">
      <div className="max-w-3xl mx-auto">
        <Link to="/login" className="text-xs text-cyan-400 hover:text-cyan-300">
          ← Voltar ao MediaHub
        </Link>

        <h1 className="mt-6 text-3xl font-bold text-white">Termos de Serviço e Licença</h1>
        <p className="mt-2 text-sm text-slate-500">MediaHub · versão Beta 2026</p>

        <div className="mt-8 space-y-7 text-sm leading-relaxed">
          <section>
            <h2 className="font-semibold text-slate-100">1. Finalidade do MediaHub</h2>
            <p className="mt-2">
              O MediaHub é uma plataforma de organização, acesso, transformação e utilização de ativos
              digitais. O sistema foi concebido e otimizado com especial atenção às necessidades de
              terapeutas integrativos, profissionais de bem-estar, formação e áreas relacionadas, embora
              possa ser utilizado por outros perfis de utilizadores compatíveis com as suas funcionalidades.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-slate-100">2. Licença de utilização</h2>
            <p className="mt-2">
              O acesso ao MediaHub concede ao utilizador uma licença limitada, pessoal, não exclusiva,
              intransmissível e condicionada ao plano contratado e às regras de utilização aplicáveis.
              A plataforma, identidade, interface, organização funcional e demais ativos próprios permanecem
              sob titularidade dos respetivos proprietários.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-slate-100">3. Conteúdos e ativos digitais</h2>
            <p className="mt-2">
              O acesso, download, transformação ou reutilização de conteúdos poderá estar sujeito a limites
              de plano, licença específica do ativo, disponibilidade técnica e regras de uso comercial.
              Conteúdos de terceiros mantêm as respetivas licenças e direitos.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-slate-100">4. Ferramentas open source</h2>
            <p className="mt-2">
              O MediaHub pode incorporar componentes open source e self-hosted. Cada componente permanece
              sujeito à sua própria licença. A presença de software open source não transfere ao utilizador
              direitos sobre o código proprietário, marca, interface ou acervo do MediaHub.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-slate-100">5. Uso terapêutico e responsabilidade profissional</h2>
            <p className="mt-2">
              As ferramentas do MediaHub destinam-se à criação, organização e transformação de conteúdo.
              A plataforma não realiza diagnóstico médico, não prescreve tratamentos e não substitui o
              julgamento profissional, clínico ou terapêutico do utilizador.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-slate-100">6. Uso adequado</h2>
            <p className="mt-2">
              Não é permitido utilizar a plataforma para violar direitos de terceiros, distribuir conteúdo
              ilícito, contornar limites de acesso, automatizar abuso de recursos ou comprometer a segurança
              da infraestrutura.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-slate-100">7. Beta e evolução do serviço</h2>
            <p className="mt-2">
              Durante a fase Beta, funcionalidades, limites, formatos e ferramentas podem ser ajustados para
              melhorar estabilidade, segurança e qualidade de utilização.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-slate-100">8. Titularidade</h2>
            <p className="mt-2">
              MediaHub é desenvolvido pela CylinderMargin Lda. Os direitos sobre conteúdos licenciados,
              componentes de terceiros e ferramentas open source permanecem com os respetivos titulares.
            </p>
          </section>
        </div>

        <p className="mt-12 border-t border-slate-800 pt-5 text-[10px] leading-relaxed text-slate-600">
          MediaHub · desenvolvido por CylinderMargin Lda. · utilização sujeita aos presentes Termos de Serviço e Licença.
        </p>
      </div>
    </div>
  </>
);

export default TermsAndLicense;
